import type { NavLink, TreatmentLink } from '@/types';

export const NAV_LINKS: NavLink[] = [
  { label: 'Início', href: '/#hero' },
  { label: 'Depoimentos', href: '/#depoimentos' },
  { label: 'Equipe', href: '/#equipe' },
  { label: 'Blog', href: '/blog' },
  { label: 'FAQ', href: '/faq' },
  { label: 'Trabalhe Conosco', href: '/trabalhe-na-habitus' },
];

export const TREATMENT_LINKS: TreatmentLink[] = [
  { label: 'Medicina Integrativa', href: '/medicina-integrativa' },
  { label: 'Soroterapia', href: '/soroterapia' },
  { label: 'Ozonioterapia', href: '/ozonioterapia' },
  // Hidrovitalis e Habitus Wellness saíram do menu em 22/09/2026: as rotas
  // estão desativadas (ver src/App.tsx).
  { label: 'Energia e Foco', href: '/energia-e-foco' },
  { label: 'Fibromialgia e Artrite', href: '/fibromialgia-e-artrite' },
  { label: 'Pós-Bariátrica', href: '/pos-bariatrica' },
  { label: 'Emagreça+', href: '/emagreca-mais' },
  { label: 'Reposição Hormonal', href: '/reposicao-hormonal' },
  { label: 'Estética Regenerativa', href: '/estetica-regenerativa' },
  { label: 'Bioimpedância InBody', href: '/bioimpedancia' },
];
